export const UPDATE_REDIRECT = 'UPDATE_REDIRECT';
export const RESET_REDIRECT = 'RESET_REDIRECT';

export const updateRedirect = (pathname: string) => ({ type: UPDATE_REDIRECT, pathname });
export const resetRedirect = () => ({ type: RESET_REDIRECT, pathname: null });
